import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer-container">
                <div className="footer-brand">
                    <Link to="/" className="footer-logo">
                        <img src="/assets/logo.png" alt="autopsyURL" />
                    </Link>
                    <p className="footer-tagline">
                        Clinical, evidence-based web debugging
                    </p>
                </div>

                <div className="footer-links">
                    <div className="footer-section">
                        <h4>Product</h4>
                        <ul>
                            <li><Link to="/">Scan URL</Link></li>
                            <li><Link to="/sessions">Sessions</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Legal</h4>
                        <ul>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                            <li><Link to="/cookies">Cookie Policy</Link></li>
                            <li><Link to="/accessibility">Accessibility</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {currentYear} autopsyURL. All rights reserved.</p>
            </div>
        </footer>
    );
}
